import React, { memo } from 'react';
import Heading from '../common/Heading';
import { ListingCards } from '../common/DiamondListing/MobileComfirmStone';
import { emptyData } from './index';
import { fetchConfirmStone, getPath, LISTINGPAGES } from './DiamondListFunctions';
import MobileGroupCard from '../common/MobileDiamondList/MobileGroupCard';
import moment from 'moment';
import { DatePicker, Drawer } from 'antd';
import BoothSideBar from '../common/DiamondListing/OfficeSidebar/BoothSideBar';

const getGroupedData = (arr, key) => {
  const data = [];
  let iter = -1;
  arr.map((x) => {
    if (x[key]) iter += 1;
    if (!data[iter]) data[iter] = [];
    data[iter].push(x);
    return true;
  });
  return data;
};

const MobileViewList = (props) => {
  // state = {}

  // showDrawer = () => {
  //     this.setState({
  //         visible: true
  //     })
  // }
  // onClose = () => {
  //     this.setState({
  //         filterOpen: false,
  //         visible: false
  //     })
  // }
  // filter = () => {
  //     this.setState({
  //         filterOpen: true
  //     })
  // }

  const self = props.parent;
  const groupData =
    getPath() === LISTINGPAGES.QUOTE
      ? props.data.map((dt) => [dt])
      : getPath() === LISTINGPAGES.OFFICE
        ? getGroupedData(props.data, 'isOfficeHeader')
        : getPath() === LISTINGPAGES.MATCHPAIR
          ? getGroupedData(props.data, 'isMatchHeader')
          : getPath() === LISTINGPAGES.CONFIRM
            ? getGroupedData(props.data, 'isConfirmHeader')
            : null;
  // <MobileGroupCard title="ROUND 0.21 H IF 2.96% EX EX EX 1297.3$/Cts">
  const title = (item) =>
    getPath() === LISTINGPAGES.QUOTE
      ? moment(item.updatedAt).format('DD/MM/YYYY')
      : getPath() === LISTINGPAGES.OFFICE
        ? moment(item.date).format('DD/MM/YYYY') +
        ' - [' +
        moment(item.cabinSlot[0].start).format('hh:mm A') +
        ' - ' +
        moment(item.cabinSlot[0].end).format('hh:mm A') +
        ']'
        : getPath() === LISTINGPAGES.MATCHPAIR
          ? item.groupingTitle
          : getPath() === LISTINGPAGES.CONFIRM
            ? item.memoNo
            : null;

  return (
    <div className="searchResultListWrapper">
      <div className="selectStonHeader">
        <div className="listingTopBlock width-100">
          <div className="d-flex justify-content-between align-items-center width-100">
            <Heading title={self.getTitle()} />
            {self?.getBooth()}
            {self.getListTop ? self.getListTop() : null}
            {/* {getPath() === LISTINGPAGES.CONFIRM && props.groupByConfirm && (
              <div style={{ margin: 10, width: '94%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <label style={{ marginRight: 8 }}>Group By:</label>
                <select value={props?.groupByConfirm} onChange={e => {
                  props.setGroupByConfirm(e.target.value);
                  props.fetchConfirmStone({ ...props.state }, props.setResponse, e.target.value);
                }}>
                  <option value="memoDetails">Order Wise</option>
                  <option value="createdAt">Date Wise</option>
                </select>
              </div>
            )} */}
            {/* {!isaccount && (
                                <div className='d-flex align-items-center mobileRightAction'>
                                    <div className='gridListIcon' onClick={self.changeGridView}>
                                        {props.listview ? (
                                            <img src={require('../../assets/svg/DiamondList/grid.svg')} alt='griIcon' />
                                        ) : (
                                            <img src={require('../../assets/svg/DiamondList/list.svg')} alt='griIcon' />
                                        )}
                                    </div>
                                    {getPath() === LISTINGPAGES.LIST && (
                                        <div className='filterOption' onClick={this.filter}>
                                            <span className='filterStatus'>3</span>
                                            <img
                                                src={require('../../assets/svg/DiamondList/filter.svg')}
                                                alt='filter'
                                            />
                                        </div>
                                    )}
                                </div>
                            )} */}
          </div>
          {self.getSelection ? self.getSelection() : null}
        </div>
      </div>

      <div className="searchInnerResult">
        {props.listView ? (
          <>
            <div className="diamondListMobile">
              {groupData ? (
                groupData.map((lItem) => {
                  return getPath() === LISTINGPAGES.UPCOMING ? (
                    <ListingCards
                      quotePage={getPath() === LISTINGPAGES.UPCOMING}
                      data={props.data}
                      currentType={props.currentType}
                    />
                  ) : (
                    <MobileGroupCard title={title(lItem[0])}>
                      <ListingCards
                        quotePage={getPath() === LISTINGPAGES.QUOTE}
                        data={lItem}
                        currentType={props.currentType}
                      />
                    </MobileGroupCard>
                  );
                })
              ) : (
                <ListingCards data={props.data} currentType={props.currentType} />
              )}
              {emptyData(props.loading, props.data.length)}
            </div>
          </>
        ) : (
          <div className="searchResultGridView">{self.getGridView()}</div>
        )}
        {self.getAction()}
      </div>

      {self?.getBooth && self?.boothPopUp}
      {/* <Drawer
                title={false}
                onClose={this.onClose}
                visible={this.state.filterOpen}
                wrapClassName='mobileFilterSideBar'
            >
                <MobileFilterSidebar />
            </Drawer> */}
    </div>
  );
};

export default MobileViewList;
